/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import { V2021_1KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmountV20211.generated';
import { V2022_1KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmountV20221.generated';
import { V2023_1KartePlannerCommentMonthlyAmountFragmentDoc } from './KartePlannerCommentMonthlyAmountV20231.generated';
export type Channel =
  /** 中国銀行 */
  | 'CHUGOKU_GINKO'
  /** ファミペイ */
  | 'FAMIPAY'
  /** 400F */
  | 'FOUR_HUNDRED_F'
  /** 400F 保険比較 */
  | 'FOUR_HUNDRED_F_INSURANCE_COMPARISON'
  /** はなさく生命 */
  | 'HANASAKU'
  /** ほけんの窓口 */
  | 'HOKEN_NO_MADOGUCHI'
  /** JCB */
  | 'JCB'
  /** ゆうちょ銀行 */
  | 'JP_BANK'
  /** きらぼし銀行 */
  | 'KIRABOSHI'
  /** ライフプラザパートナーズ */
  | 'LIFE_PLAZA'
  /** メットライフ生命 */
  | 'MET_LIFE'
  /** みんかぶ */
  | 'MINKABU'
  /** マネーフォワード */
  | 'MONEY_FORWARD'
  /** ninpath */
  | 'NINPATH'
  /** ニッセイアセットマネジメント */
  | 'NISSEI_AM'
  /** オカネコ */
  | 'OKANEKO'
  /** オカネコ転職 */
  | 'OKANEKO_TENSHOKU'
  /** OKB */
  | 'OKB'
  /** オリックス銀行 */
  | 'ORIX_BANK'
  /** Ponta */
  | 'PONTA'
  /** 楽天証券 */
  | 'RAKUTEN'
  /** 楽天証券インハウスアドバイザー */
  | 'RAKUTEN_IN_HOUSE_ADVISOR'
  /** 楽天証券の運用相談 */
  | 'RAKUTEN_UNYOU_SOUDAN'
  /** SBI証券 */
  | 'SBI'
  /** SBIマネープラザ */
  | 'SBI_MONEY_PLAZA'
  /** SBI証券の運用相談 */
  | 'SBI_UNYOU_SOUDAN'
  /** 三井住友カード */
  | 'SMCC'
  /** トヨタカローラ */
  | 'TOYOTA_COROLLA'
  /** Vitalityスマート */
  | 'VITALITY_SMART'
  /** Yahoo! JAPAN */
  | 'YAHOO'
  /** 財形住宅金融 */
  | 'ZAIKEI_JUTAKU_KINYU';

export type KartePlannerCommentMonthlyAmount_ManageOnlyFreePlanKartePlannerCommentMonthlyAmount_Fragment = { __typename: 'ManageOnlyFreePlanKartePlannerCommentMonthlyAmount' };

export type KartePlannerCommentMonthlyAmount_V2021_1KartePlannerCommentMonthlyAmount_Fragment = { __typename: 'V2021_1KartePlannerCommentMonthlyAmount', items: Array<{ channel: Types.Channel, usage: number, upperLimit: number | null }> };

export type KartePlannerCommentMonthlyAmount_V2022_1KartePlannerCommentMonthlyAmount_Fragment = { __typename: 'V2022_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit: number | null };

export type KartePlannerCommentMonthlyAmount_V2023_1KartePlannerCommentMonthlyAmount_Fragment = { __typename: 'V2023_1KartePlannerCommentMonthlyAmount', usage: number, upperLimit: number | null };

export type KartePlannerCommentMonthlyAmountFragment =
  | KartePlannerCommentMonthlyAmount_ManageOnlyFreePlanKartePlannerCommentMonthlyAmount_Fragment
  | KartePlannerCommentMonthlyAmount_V2021_1KartePlannerCommentMonthlyAmount_Fragment
  | KartePlannerCommentMonthlyAmount_V2022_1KartePlannerCommentMonthlyAmount_Fragment
  | KartePlannerCommentMonthlyAmount_V2023_1KartePlannerCommentMonthlyAmount_Fragment
;

export const KartePlannerCommentMonthlyAmountFragmentDoc = gql`
    fragment KartePlannerCommentMonthlyAmount on KartePlannerCommentMonthlyAmount {
  __typename
  ... on V2021_1KartePlannerCommentMonthlyAmount {
    ...V2021_1KartePlannerCommentMonthlyAmount
  }
  ... on V2022_1KartePlannerCommentMonthlyAmount {
    ...V2022_1KartePlannerCommentMonthlyAmount
    usage
  }
  ... on V2023_1KartePlannerCommentMonthlyAmount {
    ...V2023_1KartePlannerCommentMonthlyAmount
    usage
  }
}
    ${V2021_1KartePlannerCommentMonthlyAmountFragmentDoc}
${V2022_1KartePlannerCommentMonthlyAmountFragmentDoc}
${V2023_1KartePlannerCommentMonthlyAmountFragmentDoc}`;